import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class IvrService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  listCP(query?: any) {
    return this.get('/v2/ivr-config/cps', query);
  }

  createCP(body) {
    return this.post('/v2/ivr-config/cp', body);
  }

  updateCP(cp_id, body) {
    return this.put('/v2/ivr-config/cp/' + cp_id, body);
  }

  deleteCP(cp_id) {
    return this.delete('/v2/ivr-config/cp/' + cp_id);
  }

  detailCP(cp_id) {
    return this.get('/v2/ivr-config/cp/' + cp_id);
  }

  listState(cp_id, query?: any) {
    return this.get('/v2/ivr-config/states/' + cp_id);
  }

  createState(body) {
    return this.post('/v2/ivr-config/state', body);
  }

  updateState(state_id, body) {
    return this.put('/v2/ivr-config/state/' + state_id, body);
  }

  deleteState(state_id) {
    return this.delete('/v2/ivr-config/state/' + state_id);
  }

  detailState(state_id) {
    return this.get('/v2/ivr-config/state/' + state_id);
  }

  listChange(query?: any) {
    return this.get('/v2/ivr-config/state-changes', query);
  }

  createChange(body) {
    return this.post('/v2/ivr-config/state-change', body);
  }

  updateChange(change_id, body) {
    return this.put('/v2/ivr-config/state-change/' + change_id, body);
  }

  deleteChange(change_id) {
    return this.delete('/v2/ivr-config/state-change/' + change_id);
  }

  stateTypes() {
    return this.get('/v2/ivr-config/state-types');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Ivr.service.ts